/** Sampling display only; preserve the existing USD format without importing HTTP/i18n globals. */
export const formatProductValue = (price: number, locale = 'en-US') =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    currencyDisplay: 'narrowSymbol'
  })
    .format(price)
    .replace('$', '')
    .trim() + ' USD';

export const formatProductValueDollar = (price: number, locale = 'en-US') =>
  !Number.isFinite(price)
    ? '-'
    : '$' + formatProductValue(price, locale).replace(/ USD$/, '');
